<template>
  <div>
    <v-autocomplete
        v-model="defaultModel"
        :items="external_data_items"
        :id="control.uniqueId"
        :class="controlFieldClass"
        :name="control.name || control.uniqueId"
        @input="updateValue(computeCurrentValue)"
        :item-text="`${control.field_text}`"
        :item-value="control.field_value"
        :key="`autocomplete-${control.field_value}`"
        :hint="computeHintValue"
        :disabled="isDisabled"
        persistent-hint
        class="v-input--hide-details"
        dense
        return-object
        chips
        solo
    ></v-autocomplete>
  </div>
</template>

<script>
import {BaseControlSkeleton} from 'v-form-builder';
import {dispatchGetExternalData} from '@/store/main/actions';
import {readExternalData, readUserProfile} from '@/store/main/getters';

export default {
  name: 'DropdownControl',
  extends: BaseControlSkeleton,
  data: () => ({
    defaultModel: null,
    external_data_items: [],
    dd_text: '',
    dd_value: '',
    isDisabled: false,
  }),

  computed: {
    computeCurrentValue() {
      if (this.defaultModel) {
        return this.defaultModel[this.control.field_value];
      }
      return null;
    },
    computeHintValue() {
      if (this.defaultModel && this.control.field_hint) {
        return `${this.defaultModel[this.control.field_hint]}`;
      }
      return '';
    },
  },

  // methods: { },

  async mounted() {
    if (this.control.disableByRoleSetting) {
      const userProfile = readUserProfile(this.$store);
      this.isDisabled =
          !(userProfile?.role?.settings?.permissions?.can_edit_control_field?.methods?.can_edit_control_field);
    } else if (this.control.isDisabled) {
      this.isDisabled = true;
    }

    if (this.isDisabled) {
      return;
    }

    if (this.control.external_data_id > 0) {
      await dispatchGetExternalData(this.$store, this.control.external_data_id);
      const extData = Object.assign(await readExternalData(this.$store));
      this.external_data_items = extData.values;
      this.defaultModel = this.value;
    }

    // if (!this.value) {
    //   await Promise.all([
    //     await new Promise((resolve, reject) => setTimeout(() => resolve(), 500)),
    //     this.updateValue(this.value),
    //     this.defaultModel = this.value,
    //   ]);
    // }
  },

  watch: {
    value: {
      handler(cv, ov) {
        if (!this.defaultModel) {
          const resp = this.external_data_items.filter((e) => e[this.control.field_value] === cv)[0];
          this.defaultModel = resp ? resp : null;
        }
      },
      deep: true,
    },
  },
};
</script>

<style scoped>

</style>
